import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03090665"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "wrapper",
  class: "notification-wrapper"
}
const _hoisted_2 = { class: "content-container ml-2" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content pb-4" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: _normalizeClass(["notification", _ctx.getClassByType(item.type)]),
            style: _normalizeStyle({ top: item.top + 'px' })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.message), 1),
              _createElementVNode("div", {
                class: "close icon-ic-12",
                onClick: ($event: any) => (_ctx.removeArray(item))
              }, null, 8, _hoisted_5)
            ])
          ], 6))
        }), 128))
      ]),
      _: 1
    })
  ], 512))
}